import enums from '../enums/RdsLife.enums';
export default class MarketProduct {
  constructor({ id, photos, title, description, createdAt, price, likes, user, forSale }, inject) {
    this.id = id;
    this.photos = photos;
    this.title = title;
    this.description = description;
    this.createdAt = createdAt;
    this.price = price;
    this.likes = likes;
    this.user = user;
    this.forSale = forSale;
    this.tipologia = enums.modelTypes.MARKET_PRODUCT;
    if (!!inject && !!inject.users) {
      // let userLike = inject.users.map(u => u.likes.products).filter(l => l.indexOf(this.id) != -1);
      let usersLike = inject.users.filter(u => u.likes.products.indexOf(this.id) !== -1).map(u => u.id);
      this.likes = usersLike;
      const injectUser = inject.users.find(u => u.name === this.user.name);
      if (!!injectUser) {
        this.user = injectUser;
      }
    }
  }
}
